"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _ThemeService = require("../common/ThemeService");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import './PlayerReportCardBeta.css';

function ReportCardFilter(props) {
  var themeColor = (0, _ThemeService.getColor)();
  var themeTextColor = (0, _ThemeService.getTextColor)();
  var handleSubmit = props.handleSubmit;
  var showModal = props.open ? 'displayBlock' : 'displayNone';
  var closeFilter = closeFilter = function closeFilter(e, props) {
    props.reset();
    props.closeFilter();
    e.preventDefault();
  };
  return /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit(props.saveSettings())
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mg-modal center ".concat(showModal)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "repo-settings reportSettingCss",
    style: {
      display: 'grid',
      gridRowGap: '10px',
      gridTemplateColumns: 'auto',
      gridAutoRows: 'min-content'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick(e) {
      return closeFilter(e, props);
    },
    className: "btn btnHalo",
    style: {
      "float": "right",
      backgroundColor: themeColor
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: "centre",
    name: "fas fa-times",
    style: {
      color: themeTextColor,
      height: '15px',
      width: '15px',
      fontSize: "20px"
    },
    "data-e2e": "close"
  }))), /*#__PURE__*/_react["default"].createElement("img", {
    className: "center medal",
    src: props.medalUrl
  }), /*#__PURE__*/_react["default"].createElement("h4", {
    className: "center",
    style: {
      fontFamily: "Roboto",
      fontSize: "24px",
      fontWeight: "bold",
      letterSpacing: "0.04px",
      color: "#000000",
      alignSelf: "center"
    }
  }, props.i18next.t("lable.reportSettings")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filters grid"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "repoLabel repoRange"
  }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
    "data-e2e": "reportRangeSelect",
    name: "range",
    value: '7 days',
    component: "select",
    className: "btnHalo menuBtn repotSelect"
  }, props.access.indexOf('PLAYER') == -1 && /*#__PURE__*/_react["default"].createElement("option", {
    value: "Select",
    disabled: true
  }, props.i18next.t("lable.select")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Today"
  }, props.i18next.t("lable.Today")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Yesterday"
  }, props.i18next.t("lable.Yesterday")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Last 7 days"
  }, props.i18next.t("lable.Last 7 days")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "This Week"
  }, props.i18next.t("lable.This Week")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Last Week"
  }, props.i18next.t("lable.Last Week")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "This Month"
  }, props.i18next.t("lable.This Month")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Last Month"
  }, props.i18next.t("lable.Last Month")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "This Year"
  }, props.i18next.t("lable.This Year")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Last Year"
  }, props.i18next.t("lable.Last Year")))), props.gameType === 'cash' && /*#__PURE__*/_react["default"].createElement("label", {
    className: "repoLabel"
  }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
    "data-e2e": "reportTypeSelect",
    name: "type",
    component: "select",
    className: "btnHalo menuBtn repotSelect"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "6-seater"
  }, props.i18next.t("lable.6-max")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "Full Ring"
  }, props.i18next.t("lable.Full Ring")))), props.gameType === 'cash' && /*#__PURE__*/_react["default"].createElement("label", {
    className: "repoLabel"
  }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
    name: "level",
    component: "select",
    className: "btnHalo menuBtn repotSelect",
    "data-e2e": "all-level"
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: "All Level"
  }, props.i18next.t("lable.allStakes")), props.levels.map(function (obj, index) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: index,
      value: obj.SB + "/" + obj.BB
    }, obj.SB + "/" + obj.BB);
  }))), /*#__PURE__*/_react["default"].createElement("button", {
    "data-e2e": "saveReportChanges",
    className: "prc-btn saveReportButton btnHalo",
    style: {
      fontSize: '12px',
      backgroundColor: themeColor,
      borderColor: themeColor,
      color: themeTextColor
    }
  }, props.i18next.t("lable.saveSettings")))))));
}
ReportCardFilter = (0, _reduxForm.reduxForm)({
  form: 'reportCardSettingFilter'
})(ReportCardFilter);
ReportCardFilter = (0, _reactRedux.connect)(function (state) {
  var reportCardSettingFilter = state.multipleReportCards.reportCardSetting.filter(function (obj) {
      return obj.gameType === state.multipleReportCards.gameType;
    })[0],
    range = reportCardSettingFilter.hitRange,
    type = reportCardSettingFilter.hitType,
    level = reportCardSettingFilter.hitLevel;
  return {
    range: range,
    type: type,
    level: level,
    initialValues: {
      range: range,
      type: type,
      level: level
    },
    gameType: state.multipleReportCards.gameType
  };
})(ReportCardFilter);
var _default = ReportCardFilter;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/reportCardFilter.js
 ** module id = 2405
 ** module chunks = 0
 **/